{
  "player_0": { "name": "Pigeon" },
  "player_1": { "name": "Banana" }
}
